function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { AddressManualType } from 'swag-client-common/constants';
import classnames from 'classnames';
import PopupContent from './components/popup-content/popup-content';
import classes from './confirm-your-address-popup.scss';
const styles = {
  body: {
    textAlign: 'center'
  }
};
export default class ConfirmYourAddressPopup extends React.PureComponent {
  constructor(...args) {
    super(...args);
    // @todo. auto generated. fix this error
    // @ts-ignore
    _defineProperty(this, "state", {
      chosenAddress: null,
      address: null
    });
    _defineProperty(this, "handleAddressEnter", () => {
      const {
        onEnterAddress
      } = this.props;
      const {
        chosenAddress
      } = this.state;

      // @todo. auto generated. fix this error
      // @ts-ignore
      onEnterAddress(chosenAddress);
    });
    _defineProperty(this, "handleAddressClick", chosenAddress => {
      this.setState({
        chosenAddress
      });
    });
    _defineProperty(this, "handleSubmit", () => {
      const {
        chosenAddress
      } = this.state;
      const {
        onConfirmAddress
      } = this.props;

      // @todo. auto generated. fix this error
      // @ts-ignore
      onConfirmAddress(chosenAddress);
    });
  }
  componentDidUpdate(prevProps) {
    const {
      params: {
        confirmAddresses = []
      }
    } = this.props;
    if (prevProps.params.confirmAddresses !== confirmAddresses) {
      const chosenAddress = confirmAddresses.length > 1 ? AddressManualType.ADDRESS_SUGGESTED : AddressManualType.ADDRESS_ENTERED;
      this.setState({
        chosenAddress
      });
    }
  }
  render() {
    const {
      chosenAddress
    } = this.state;
    const {
      onClose,
      isOpen,
      titleText,
      saveText,
      popupClassName,
      buttonClassName,
      activeBorderClassName,
      params: {
        confirmAddresses = []
      }
    } = this.props;
    return /*#__PURE__*/React.createElement(InfoDialog, {
      open: isOpen,
      showCloseButton: true,
      bodyStyle: styles.body,
      bodyClassName: classes.body,
      contentWrapperClassName: classnames(classes.content, popupClassName),
      titleClass: classes.title,
      onRequestClose: onClose,
      content: /*#__PURE__*/React.createElement(PopupContent, {
        titleText: titleText,
        saveText: saveText
        // @todo. auto generated. fix this error
        // @ts-ignore
        ,
        chosenAddress: chosenAddress,
        confirmAddresses: confirmAddresses,
        buttonClassName: buttonClassName,
        activeBorderClassName: activeBorderClassName,
        onSubmitClick: this.handleSubmit,
        onEditClick: this.handleAddressEnter,
        onAddressClick: this.handleAddressClick
      })
    });
  }
}